import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'
import { NgPipesModule } from 'ngx-pipes'

import { ComponentsModule } from '../../components/components.module'
import { HtmlContentPipe } from '../../shared/pipes/html-content.pipe'
import { HtmlToPlaintextPipe } from '../../shared/pipes/html-to-plaintext.pipe'
import { LocalizedDatePipe } from '../../shared/pipes/localized-date.pipe'
import { ProcessContentPipe } from '../../shared/pipes/process-content.pipe'
import { ProcessFootnotesPipe } from '../../shared/pipes/process-footnotes.pipe'
import { SharedModule } from '../../shared/shared.module'
import { ArticleActionButtonsComponent } from './article-details/components/article-action-buttons/article-action-buttons.component'
import { IndexComponent } from './article-details/components/index/index.component'
import { ArticlesRoutingModule } from './articles-routing.module'

@NgModule({
  exports: [
    ArticleActionButtonsComponent,
    ProcessFootnotesPipe,
    IndexComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ArticlesRoutingModule,
    ComponentsModule,
    SharedModule,
    NgPipesModule,
    ProcessContentPipe,
    HtmlContentPipe,
    HtmlToPlaintextPipe,
    ProcessFootnotesPipe,
    LocalizedDatePipe,
    TranslatePipe,
    IndexComponent,
    ArticleActionButtonsComponent,
  ],
})
export class ArticlesModule {}
